export const TOKEN_KEY = 'auth_token';

export const authService = {
    // Token management
    getToken: () => {
        return localStorage.getItem(TOKEN_KEY);
    },

    setToken: (token) => {
        localStorage.setItem(TOKEN_KEY, token);
    },

    removeToken: () => {
        localStorage.removeItem(TOKEN_KEY);
    },

    // Check if user is authenticated
    isAuthenticated: () => {
        return !!authService.getToken();
    }
};